// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RL_B","tabsBox":"styles_tabsBox__yMTOH","createButton":"styles_createButton__2o69P"};